module.exports = function(tokens) {
  return {
    scrimBackgroundColor: tokens.themeBackgroundOverlayDefault,
    scrimMotionTiming: "150ms",
    scrimMotionFunction: "ease",
    scrimElevation: 60
  }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@meridian/tokens/component/scrim.js
// module id = 433
// module chunks = 0